export const langIt = {
  html_title: 'AlcmeonChat',
  title: 'I vostri consulenti a distanza',
  subtitle: 'Rispondiamo a tutte le vostre domande - ',
  privacy_link_prefix: "Potete leggere la nostra politica sulla privacy",
  privacy_link_label: 'qui',
  send_a_message: 'Invia un messaggio...',
  send_your_email: 'Inserisci il tuo indirizzo e-mail...',
  send_your_phone: 'Inviate il vostro numero di telefono, nel formato +33612345678',
  select_an_option: "Selezionare un'opzione",
  close_menu: 'Chiudere il menù',
  'aria_label/close': 'chiudere',
  'aria_label/close-menu': 'chiudere il menù',
  'aria_label/file-upload': `caricare un'immagine o un documento PDF`,
  'aria_label/open_alcmeon_inmessage': 'aprire il chiacchierata',
  'aria_label/options': 'opzioni',
  'aria_label/send_message': 'inviare il messaggio',
  'alt/an_image': `un'immagine`,
  helperMessage1: `Ciao 🙂<br/>Hai una domanda?`,
  helperMessage2: `Siamo qui per aiutarvi.`,
  helperMessage3: `<strong>Hai una conversazione in corso</strong>`,
  helperMessage4: `Continua qui 👉`,
  waitingMessage: `Un consulente le risponderà al più presto. Sei attualmente nella posizione {{position}}. Il tempo di attesa previsto è {{time}}, attendere prego.`,
  lessThan:'meno di',
  moreThan:'più di',
  minutes:'min'
};
